import {
  Component,
  Input,
  ViewEncapsulation,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ProductPack } from '../../models/product-pack';
import { MatDialog } from '@angular/material/dialog';
import { ProductInfoPopupComponent } from '../product-info-popup/product-info-popup.component';
import { environment } from '../../../../../environments/environment';
import { PinPopupComponent } from 'src/app/components/pin-popup/pin-popup.component';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ProductsService } from 'src/app/modules/order/services/products.service';
import { UpDownComponent } from '../up-down/up-down.component';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { MessageComponent } from 'src/app/modules/general/components/message/message.component';

@Component({
  selector: 'app-product-pack',
  templateUrl: 'product-pack.component.html',
  styleUrls: ['product-pack.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProductPackComponent implements OnInit {
  @Input() productPack: ProductPack;
  @Input() countUpEnabled: boolean;
  @Input() singleProductView = false;
  @Output() counterChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() productPackUnlocked: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('upDown') upDownComponentRef;

  faQuestionCircle = faQuestionCircle

  constructor(
    public dialog: MatDialog,
    private productsService: ProductsService,
  ) { }

  ngOnInit() {
  }

  onCounterChanged(counter) {
    this.counterChanged.emit(counter);
  }

  get cssClassHeader() {
    return this.singleProductView ? 'col-4 vertical-align' : 'col-3 center';
  }

  get cssClassCounters() {
    return this.singleProductView ? 'col-5' : 'col-6';
  }

  onProductPackIconClick(productPack: ProductPack) {
    if (!productPack || !productPack.products || productPack.products.length === 0) {
      return;
    }

    this.dialog.open(ProductInfoPopupComponent, {
      data: { product: productPack.products[0] }
    });
  }

  toMoneyStr(x: number): string {
    return environment.globalSettings.toMoneyStr(x);
  }

  get price(): string {
    const price = this.productPack.totalPrice;
    if (price != null) {
      return this.toMoneyStr(price);
    }

    return null;
  }

  get description(): string {
    if (this.productPack.totalPrice && this.productPack.description && this.productPack.description !== 'false') {
      return this.productPack.description;
    }

    return null;
  }

  get productDescription(): string {
    if (this.productPack.productDescription 
      && this.productPack.productDescription !== 'false' 
      && this.productPack.productDescription !== this.productPack.description) {
      return this.productPack.productDescription;

    }

    return null;
  }

  get productSaleDescription(): string {
    return this.productPack.productSaleDescription || '';
  }

  onSaleDescriptionClick(): void {
    const dialogRef = this.dialog.open(MessageComponent, {
      disableClose: true,
      data: {
        title: this.productPack.name,
        message: this.productSaleDescription,
        hideIcon: true,
        hideNoButton: true,
        yesCaption: 'Close',
      }
    });
  }

  unlockProductPack(productPack: ProductPack): void {
    const dialogRef = this.dialog.open(PinPopupComponent, {
      data: {
        validatePinMethod: (pin: string): Observable<any> => {
          return this.validatePin(pin, productPack);
        }
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      if (dialogRef.componentInstance.pinValid && productPack) {
        productPack.setUnlocked();
        productPack.selectVariantProduct(dialogRef.componentInstance.result);
        this.upDownComponentRef.countChangeByOne(true);
        this.productPackUnlocked.emit();
      }
    });
  }

  validatePin(pin: string, productPack: ProductPack): Observable<any> {
    return of(true).pipe(
      switchMap(() => {
        if (!productPack?.requiredPinProduct?.id || !pin) {
          return of(false);
        }

        if (productPack?.variantsProducts) {
          return this.productsService.findVariantProductByPin(pin, productPack?.requiredPinProduct?.productTemplateId);
        }

        return this.productsService.checkProductPin(productPack?.requiredPinProduct?.id, pin);
      }),
    );
  }
}
